<template>

    <b-col :cols="cols" :lg="lg">

        <fakeInput/>

    </b-col >

</template>

<script>

    import fakeInput from '@/components/fakeInput'

    export default {

        props: ['cols','lg'],

        components: {

            fakeInput

        }
        
    }

</script>